import {useStore} from "core/react/useStore";
import {MetricConfiguration} from "areas/metrics/components/MetricSelector/types";

import {MetricValueHolder} from "areas/metrics/metricValueHolder";

export function useMetricValue(metricConfiguration: MetricConfiguration) {
	return useStore(() => new MetricValueHolder([metricConfiguration]))
}
